// @core/api/endpoints/authn/get_oauth2_consent.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  OAuth2ConsentResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Get OAuth2 consent details
 * Retrieves the current consent status for a specific OAuth2 client including granted scopes and expiration time.
 */
export async function GetOAuth2Consent(
  client_id: string,
  options?: RequestOptions
): Promise<OAuth2ConsentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/oauth2/consents/:client_id`;
  requestPath = requestPath.replace(':client_id', encodeURIComponent(client_id));
  const requestOptions = options;
  return client.get<OAuth2ConsentResponse>(requestPath, { ...requestOptions });
}
